import push from '../../utils/routing';

export default (spaceId) => () =>
  push({
    pathname: `/dashboard/${spaceId}/community/feed`,
    query: {},
  });
